import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import RouteUtils from '../../../modules/routeUtils';
import useIsMobile from '../../../hooks/useIsMobile';

import styles from './BlogSidebar.module.postcss';

function BlogSearch() {
  const history = useHistory();
  const location = useLocation();
  const isMobile = useIsMobile();

  const [value, setValue] = useState(null);

  // Prefill query from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get('q') || '';
    setValue(query);
  }, [location.search]);

  const handleChange = (val) => {
    setValue(val);
  };

  const onSubmit = () => {
    RouteUtils.updateQueryParam(
      history,
      location,
      { q: value },
      '/blog-search'
    );
  };

  const onClear = () => {
    handleChange(null);
  };

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <div className={styles.BlogSearch} role='search'>
      <label htmlFor='blog-search' className='u-sr-only'>Search blog posts</label>
      <img src='/static/images/search.svg' alt='' width='15' height='16' aria-hidden='true' />
      <input
        id='blog-search'
        onChange={e => handleChange(e.target.value)}
        onKeyUp={onKeyUp}
        value={value || ''}
        enterKeyHint='search'
      />
      { !!value &&
        <button type='button' onClick={onClear} aria-label='Clear search'>
          <img src='/static/images/admin/x-black.svg' alt='' width='10' height='10' aria-hidden='true' />
        </button>
      }
    </div>
  );
}

export default BlogSearch;
